import React, { useState, useEffect, useRef } from "react";

const BaseSelectorButton = () => {
  const [selectedBase, setSelectedBase] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const bases = JSON.parse(localStorage.getItem("bases") || "[]");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const storedBaseId = localStorage.getItem("baseSelected");
    const storedBase = bases.find((base) => String(base.id) === storedBaseId);
    if (storedBase) {
      setSelectedBase(storedBase.nome);
    }
  }, [bases]);

  const handleSelect = (base) => {
    setSelectedBase(base.nome);
    localStorage.setItem("baseSelected", base.id);
    setDropdownOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        type="button"
        className="w-full border-0 px-3 py-3 text-blueGray-600 font-bold bg-white rounded text-sm shadow focus:outline-none focus:ring transition-all duration-150"
        onClick={() => setDropdownOpen((prev) => !prev)}
      >
        {selectedBase || "Selecione a base"}
      </button>
      {dropdownOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white text-lcsm rounded shadow-lg">
          {bases.map((base, index) => (
            <div
              key={index}
              className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
              onClick={() => handleSelect(base)}
            >
              {base.nome}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BaseSelectorButton;
